<template>
  <div>
    <div class="vx-row">
      <div v-for="(i, index) in marketplaceIntegrationList" :key="index"
        class="cursor-pointer vx-col w-full lg:w-1/3 xl:w-1/3 mb-base">
        <IntegrationItem :data="i" />
      </div>
      <div class="flex w-full place-items-center justify-center">
        <p>Couldn't find what you were looking for?</p>
        <vs-button class="ml-4" size="medium" color="primary" type="filled" onclick="">Request Integration</vs-button>
      </div>
    </div>
  </div>
</template>
<script>
import marketplaceIntegrationList from "@/assets/data/marketplace-integrations-list.js";
import IntegrationItem from "./components/IntegrationItem.vue";
export default {
  components: { IntegrationItem },
  data() {
    return {
      marketplaceIntegrationList,
    };
  },
};
</script>

<style scoped>
.marketplace--item-card {
  transition: ease-in-out 0.3s;
}

.marketplace--item-card:hover {
  background: #fffdf7 !important;
  box-shadow: 0px 8px 40px rgba(242, 194, 68, 0.05);
  transform: scale(1.03);
}
</style>
